/**
 * Maps captured KinderConnect TWC compliance data (photo, signature, GPS) onto the
 * `kinderConnectMedia` GraphQL mutation input.
 *
 * @param kcData - The captured values from the KinderConnect capture modal, or `undefined` if
 * capture wasn't required for this sign-in/out (KC capture disabled).
 * @returns The mutation input, or `undefined` when no capture was performed.
 */
export const adaptKinderConnectCaptureFormValuesToMediaInput = (kcData) => kcData
    ? {
        photo: kcData.photoBase64,
        signature: kcData.signatureBase64,
        latitude: kcData.latitude,
        longitude: kcData.longitude,
    }
    : undefined;
